import apiClient from './apiClient';
import { GET_PAYMENT_REQUEST_BY_ID_API } from './apiUrl';

const getPaymentHistoryByIdApi = id => {
  return apiClient.get(GET_PAYMENT_REQUEST_BY_ID_API(id));
};

export { getPaymentHistoryByIdApi };
